import CallApi from "../../util/CallApi";

export const FETCH_ADDRESS = "FETCH_ADDRESS";
export const FETCH_ADDRESS_SUCCESS = "FETCH_BRANDS_SUCCESS";
export const FETCH_ADDRESS_FAILURE = "FETCH_ADDRESS_FAILURE";

const callApi = new CallApi();

export const fetchAddress = params => dispatch => {
  dispatch({ type: FETCH_ADDRESS });
  return callApi
    .postSecurity("/query/address", params)
    .then(data => {
      dispatch({ type: FETCH_ADDRESS_SUCCESS, payload: data });
    })
    .catch(error => dispatch({ type: FETCH_ADDRESS_FAILURE }));
};
